var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useLayoutEffect, useState } from "react";
import YU_COLOURS from "../../../styles/colours";
import styled from "styled-components";
import { BaseModal, MODAL_ID } from "./base/BaseModal";
import { CloseButton } from "./styles";
import { Icon } from "../../..";
export var SideBarModal = function (_a) {
    var closeOnClickOutside = _a.closeOnClickOutside, showModal = _a.showModal, closeModal = _a.closeModal, children = _a.children;
    var _b = useState(false), slideIn = _b[0], setSlideIn = _b[1];
    useLayoutEffect(function () {
        if (showModal) {
            setTimeout(function () {
                setSlideIn(true);
            }, 150);
        }
        else {
            setSlideIn(false);
        }
    }, [showModal]);
    return (React.createElement(BaseModal, { showModal: showModal, closeOnClickOutside: closeOnClickOutside, closeModal: closeModal, align: "right" },
        React.createElement(SideBarDialog, { slideIn: slideIn, hidden: !showModal, "aria-hidden": !showModal, id: MODAL_ID, "aria-label": MODAL_ID, "aria-modal": "true", role: "dialog" },
            React.createElement(FullHeight, null, children),
            React.createElement(ExitWrapper, null,
                React.createElement(CloseButton, { onClick: closeModal, "aria-label": "close" },
                    React.createElement(Icon, { name: "exit", fill: YU_COLOURS.B1100 }))))));
};
var PADDING = "2.5rem";
var WIDTH = "32rem";
export var FullHeight = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: calc(100vh - ", " * 2);\n"], ["\n  height: calc(100vh - ", " * 2);\n"])), PADDING);
export var ExitWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n"], ["\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n"])));
export var SideBarDialog = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  translate: ", ";\n  width: ", ";\n  transition: 250ms;\n  transition-timing-function: ease-out;\n  height: 100%;\n  max-height: 100%;\n  overflow: auto;\n  padding: ", ";\n  gap: 2rem;\n  background: ", ";\n  border-radius: 8px 0px 0px 8px;\n"], ["\n  translate: ", ";\n  width: ", ";\n  transition: 250ms;\n  transition-timing-function: ease-out;\n  height: 100%;\n  max-height: 100%;\n  overflow: auto;\n  padding: ", ";\n  gap: 2rem;\n  background: ", ";\n  border-radius: 8px 0px 0px 8px;\n"])), function (p) { return (p.slideIn ? "0rem 0" : WIDTH + " 0"); }, WIDTH, PADDING, YU_COLOURS.B210);
var templateObject_1, templateObject_2, templateObject_3;
